import { render, staticRenderFns } from "./wb-subscribe-management.vue?vue&type=template&id=484b3673"
import script from "./wb-subscribe-management.vue?vue&type=script&lang=js"
export * from "./wb-subscribe-management.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports